import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { GlobalModalService } from 'src/app/core/services/global-modal.service';
import { CustomRouteData } from 'src/app/core/utils/routing-util';
import { isString } from 'src/app/core/utils/type-util';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  const globalModalService = inject(GlobalModalService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const routeData: CustomRouteData = route.data as CustomRouteData;
  const isAuthenticated = await authService.isAuthenticatedAsync();

  if (isAuthenticated) {
    if (authService.user.agree) {
      let isEntitled = true;
      if (isString(routeData.entitlementUrl)) {
        isEntitled = authService.isEntitled(routeData.entitlementUrl);
      } else if (routeData.entitlementUrl != null) {
        isEntitled = routeData.entitlementUrl(authService);
      }

      if (!isEntitled) {
        globalModalService
          .alert(
            {
              headerText: 'Access Denied',
              bodyText: `You are not entitled to view this page (${state.url})`,
              showCloseButton: false
            },
            {
              backdrop: 'static',
              keyboard: false
            }
          )
          .then(() => {
            router.navigate(['/private']);
          });
      }

      return isEntitled;
    } else {
      router.navigate(['/terms-of-use']);
      return false;
    }
  } else {
    globalModalService.alert({
      headerText: 'Access Denied',
      bodyText: 'Please log in to continue.'
    });

    if (authService.isOktaAuthenticated()) {
      router.navigate(['/logout']);
    } else {
      router.navigate(['/logout']);
      authService.loginRedirect = state.url;
    }

    return false;
  }
};
